import api from './api';
// 获取组织信息
export function getOrglist(params) {
  return api.post('/org/all.html', params, false, false).then(res => res.data);
}
// 获取组织信息
export function getdiclistbypid(params) {
  return api.post('/dic/getdiclistbypid', params, false, false).then(res => res.data);
}

// 获取前端数据字典信息
export function getFrontVieDic(params) {
  return api.post('/dic/getdiclistbypid', params, false, false).then(res => res.data);
}

/**
 * @description 获取新闻列表
 * @param {obj} params
 * @description newsType新闻小类
 *行业动态 2
 *企业要闻 3
 *权威观点 4
 *联盟活动 5
 *讨论会议 6
 *会展资讯 7
 *知识共享 8
 *博士讲堂 9
 *专家解析 10
 *权威报告 11
 */
export function sysNewsData(params) {
  return api.post('/news/getlistbycount', params, true, false).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/common.js